/**
 * Explicit sign-out: start the relay revoke with the live token BEFORE the local
 * clear drops it. Not awaited, not retried (a queued revoke keeps a credential).
 */
export function signOutOrdered(deps: {
  hasToken: () => boolean;
  revoke: () => Promise<void>;
  clear: () => void;
  report: (err: unknown) => void;
}): void {
  const revoke = deps.hasToken() ? deps.revoke() : undefined;
  deps.clear();
  void revoke?.catch(deps.report);
}
